(function () {
  function initSwatchImageSwap(root) {
    var cards = (root || document).querySelectorAll('[data-product-card]');

    cards.forEach(function (card) {
      var mediaLink = card.querySelector('[data-card-media-link]');
      if (!mediaLink) return;

      var img = mediaLink.querySelector('img');
      if (!img) return;

      var swatchLinks = card.querySelectorAll('[data-swatch-link]');

      swatchLinks.forEach(function (swatch) {
        if (swatch.dataset.swapBound === 'true') return;
        swatch.dataset.swapBound = 'true';

        swatch.addEventListener('click', function (event) {
          var newImage = swatch.getAttribute('data-variant-image');
          if (!newImage) return;

          event.preventDefault();

          swatchLinks.forEach(function (s) {
            s.classList.remove('is-selected');
          });
          swatch.classList.add('is-selected');

          img.src = newImage;
          if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
          if (img.hasAttribute('sizes')) img.removeAttribute('sizes');

          var variantHref = swatch.getAttribute('href');
          if (variantHref) mediaLink.setAttribute('href', variantHref);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSwatchImageSwap(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initSwatchImageSwap(event.target);
  });

  window.initSwatchImageSwap = initSwatchImageSwap;
})();